var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-hint-pane flex column"},[_vm._m(0),_vm._m(1),_c('div',[_c('button',{staticClass:"normal",on:{"click":_vm.onReload}},[_vm._v("重新加载")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/img/loading_failed.png"),"alt":""}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('span',[_vm._v("加载失败，请重试")])])
}]

export { render, staticRenderFns }